/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import getThumbnailUrls from '../../helpers/getThumbnailUrls';
import { setThumbnailUrls } from '../helpers/assets';

const getThumbnailAssetId = (item) => item?.coverAssetId || item?.assetId || null;

export const fetchThumbnails = createAsyncThunk(
  'products/fetchThumbnails',
  async ({ assetIds }, {
    extra: { Logger, Toast },
    getState,
  }) => {
    try {
      const thumbs = await getThumbnailUrls(assetIds);
      const storageType = getState().user?.team?.storageType;
      return { thumbs, storageType };
    } catch (error) {
      Logger.log('UI', 'ToastProductsNotLoaded');
      Toast(
        'Products not loaded. Refresh and try again',
        { autoClose: false, type: 'error' },
      );
      Logger.error(new Error('Error products fetching'), { error }, [
        'FetchProductsFailed',
        { errorMessage: 'Products can not be fetched from backend.' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    fetchThumbnails.pending,
    () => {
      // do nothing
    },
  ).addCase(
    fetchThumbnails.fulfilled,
    (state, { payload: { thumbs, storageType } }) => {
      const thumbnailTargets = state.search.items
        .map((item) => ({
          item,
          assetId: getThumbnailAssetId(item),
        }))
        .filter((entry) => entry.assetId);

      if (!thumbnailTargets.length) return;

      const assetsStub = thumbnailTargets.map(({ assetId }) => ({ _id: assetId }));
      const normalizedAssets = setThumbnailUrls(assetsStub, thumbs, storageType === 's3');

      normalizedAssets.forEach((asset, index) => {
        if (asset.thumbnail) {
          thumbnailTargets[index].item.thumbnail = asset.thumbnail;
        }
      });
    },
  ).addCase(
    fetchThumbnails.rejected,
    (state, { error }) => {
      state.error = error;
    },
  );
};
